export default "__VITE_ASSET__UvSZSLwX__"